import { useQuery } from "react-query";

import { fetchDeploymentRepos } from "@api";
import { useOrg } from "@hooks/useOrg";

/*
 * Returns query result with repos from current selected org
 * Repos returned: [
 *    setup_repos (sorted by last completed scan)
 *    not_setup_repos (sorted by name)
 * ]
 */
export const useRepos = () => {
  const org = useOrg();

  return useQuery(
    ["repos", { org }],
    () =>
      fetchDeploymentRepos(org?.id!).then((response) => {
        return response.repos;
      }),
    {
      enabled: !!org,
    }
  );
};
